var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 340,
    fill: "#DFDEDE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 159,
    r: 77,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 252C83.5 252.4 64.1667 275.5 58 287C84.5 315.5 134.5 335 169 332.5C220.5 335 284.5 294 280.5 287C264.5 259 237.833 252.333 223 252C197.5 251.833 139.5 251.6 111.5 252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.92ddf073e99f1a68d954317e10f8e5e2.svg";
export { ForwardRef as ReactComponent };